export default __webpack_public_path__ + "static/media/upArrow.b8a9ef30.svg";